import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=42677702&"
import script from "./Suspended.vue?vue&type=script&lang=js&"
export * from "./Suspended.vue?vue&type=script&lang=js&"
import style0 from "./Suspended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports